import { render, staticRenderFns } from "./modaImportarImagenes.vue?vue&type=template&id=1452db43&scoped=true"
import script from "./modaImportarImagenes.vue?vue&type=script&lang=js"
export * from "./modaImportarImagenes.vue?vue&type=script&lang=js"
import style0 from "./modaImportarImagenes.vue?vue&type=style&index=0&id=1452db43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452db43",
  null
  
)

export default component.exports